import { get, post } from '../axios'

// 国家选项列表
export function addressValidate_countryList_get(map, option) {
  return get(
    `${process.env.VUE_APP_ADDRESSVALIDATE}/addressValidate/countryList`,
    map,
    option
  ).then(response => response)
}

// 地址策略详情
export function addressValidate_detail_get(map, option) {
  return get(
    `${process.env.VUE_APP_ADDRESSVALIDATE}/addressValidate/detail`,
    map,
    option
  ).then(response => response)
}

// 编辑地址策略
export function addressValidate_edit_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADDRESSVALIDATE}/addressValidate/edit`,
    map,
    option
  ).then(response => response)
}

// 查询操作日志
export function addressValidate_operateLog_get(map, option) {
  return get(
    `${process.env.VUE_APP_ADDRESSVALIDATE}/addressValidate/operateLog`,
    map,
    option
  ).then(response => response)
}

// 分页查询地址策略
export function addressValidate_pageByCondition_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADDRESSVALIDATE}/addressValidate/pageByCondition`,
    map,
    option
  ).then(response => response)
}

// 更改策略状态
export function addressValidate_updateStatus_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADDRESSVALIDATE}/addressValidate/updateStatus`,
    map,
    option
  ).then(response => response)
}
